<template>
  <section>
    <div class="dialog-body">
      <el-form
        ref="send-form"
        :rules="rules"
        :model="sendFormData">
        <template   v-if="has_share">
          <div
            class="form-item">
            <span class="mg-l-28">Referrer</span>
            <el-form-item >
              <div class="flex-align-center">
                <v-checkbox
                  v-if="!isOnlyReferrer"
                  v-model="sendFormData.is_referrer_send"
                  :is-boolean="false"
                  class="mg-r-15"></v-checkbox>
                <v-input
                  :value="referSendValue"
                  disabled
                />
              </div>
            </el-form-item>

          </div>
          <div class="form-item">
            <el-form-item
              prop="referrer_content"
              :rules="sendFormData.is_referrer_send==1?rules.input:[]">
              <v-input
                v-model="sendFormData.referrer_content"
                :disabled="sendFormData.is_referrer_send==0&&!isOnlyReferrer"
                type="textarea"
                :rows="4" />
            </el-form-item>
          </div>
        </template>
        <template v-if="!isOnlyReferrer">
          <div>
            <div class="form-item">
              <span>Policyholder (SMS)</span>
              <el-form-item >
                <div class="flex-align-center">
                  <v-checkbox
                    v-model="sendFormData.is_sms_send"
                    :is-boolean="false"
                    class="mg-r-15"></v-checkbox>
                  <v-input
                    :value="policyholderSMS"
                    disabled
                  />
                </div>
              </el-form-item>
            </div>
            <div class="form-item">
              <el-form-item
                prop="sms_content"
                :rules="sendFormData.is_sms_send==1?rules.input:[]">
                <v-input
                  v-model="sendFormData.sms_content"
                  type="textarea"
                  :rows="4" />
              </el-form-item>
            </div>
          </div>
          <div>
            <div class="form-item">
              <span>Policyholder (Email)</span>
              <el-form-item >
                <div class="flex-align-center">
                  <v-checkbox
                    v-model="sendFormData.is_email_send"
                    :is-boolean="false"
                    class="mg-r-15"></v-checkbox>
                  <v-input
                    :value="policyholderEmail"
                    disabled
                  />
                </div>
              </el-form-item>
            </div>
            <div class="form-item">
              <el-form-item
                prop="email_content"
                :rules="sendFormData.is_email_send==1?rules.input:[]">
                <v-input
                  v-model="sendFormData.email_content"
                  type="textarea"
                  :rows="4" />
              </el-form-item>
            </div>
          </div>
        </template>
      </el-form>
      <div class="flex-sb-center">
        <div>
          <v-button
            gray
            @click="onCancel">Cancel</v-button>
        </div>
        <div>
          <v-button
            v-if="skip"
            gray
            @click="onSkip">Skip</v-button>
          <v-button
            green
            :disabled="!can_send"
            @click="onSend">Send</v-button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'

export default {
  name: 'sendTypeContent',
  mixins: [MixinRules,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    initSmsContent: {
      type: String,
      default: ''
    },
    initEmailContent: {
      type: String,
      default: ''
    },
    initReferContent: {
      type: String,
      default: ''
    },
    skip: {
      type: Boolean,
      default: true
    },
    showUsername:{
      type: Boolean,
      default: false
    },
    value:{
      type: Boolean,
      default: false
    },
    isEdit:{
      type: Boolean,
      default: false
    },
    isFina:{
      type: Boolean,
      default: false
    },
    isRenew:{
      type: Boolean,
      default: false
    },
    updateContent: {
      type: Boolean,
      default: false
    },
    isOnlyReferrer:{
      type: Boolean,
      default: false
    },
    isAccountReferrer:{
      type: Boolean,
      default: false
    },
    isCloseShare:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        sms_content: '',
        email_content: '',
        share_content: '',
        referrer_content: '',
        send_type:'',
        is_sms_send:1,
        is_email_send:1,
        is_referrer_send:0,
      }
    }
  },
  computed: {
    can_send(){
      let {is_share_send,is_sms_send,is_email_send,referrer_send} = this.sendFormData||{}
      return is_share_send==1||is_sms_send==1||is_email_send==1||this.isOnlyReferrer||!this.isOnlyReferrer&&referrer_send==1
    },
    referrer(){
      let {referrer={},share_user_infos={}} = this.form||{}
      let data = {}
      if(JSON.stringify(referrer) != '[]')
        data = referrer
      return data||{}
    },
    has_share(){
      return JSON.stringify(this.referrer) != '{}'
    },
    referSendValue(){
      let {isrd_nm,send_mobile,send_email,identity,phone} = this.referrer||{}
      return `${isrd_nm} - ${this.type!=2?send_mobile:send_mobile}`
    },
    hasSendEmail(){
      let {isrd_nm,send_mobile,send_email} = this.referrer||{}
      return !!send_email
    },
    isEmail() {
      if(this.type == 0) {
        return !this.isPersonal
      }
      if(this.type == 2) {
        return true
      }
      return false
    },
    isPersonal() {
      const { identity, cust_typ } = this.form||{}
      if(identity && identity == 1) {
        return true
      }
      if(cust_typ && cust_typ == 1) {
        return true
      }
      return false
    },
    currentName() {
      const { isrd_lst_nm, isrd_fst_nm, contact_nm, isrd_nm } = this.form||{}
      let name = ''
      if(isrd_nm){
        name = isrd_nm
      }else{
        name =  `${isrd_lst_nm} ${isrd_fst_nm}`
      }
      return this.isPersonal?name:contact_nm
    },
    sendContact(){
      let {send_type} = this.sendFormData||{}
      const {
        mobile_no,
        contact_email,
        phone,
        email,
        contact_phone,
        draft_email,
        phone_no } = this.form||{}
      let send_phone = contact_phone||mobile_no || phone || phone_no

      if(send_type==3) {
        return this.currentName?`${this.currentName} - ${send_phone},${email}`:`${send_phone},${email}`
      }
      if(send_type==2)
        return  this.currentName?`${this.currentName} - ${email}`:email
      return  this.currentName?`${this.currentName} - ${send_phone}`:send_phone
    },
    policyholderSMS(){
      const {
        mobile_no,
        contact_email,
        phone,
        email,
        contact_phone,
        draft_email,
        phone_no } = this.form||{}
      let send_phone = contact_phone||mobile_no || phone || phone_no
      return  this.currentName?`${this.currentName} - ${send_phone}`:send_phone
    },
    policyholderEmail(){
      const {
        email,
        contact_phone,
        draft_email,
      } = this.form||{}
      return  this.currentName?`${this.currentName} - ${email}`:email


    },
    currentContact() {
      const {
        mobile_no,
        contact_email,
        phone,
        email,
        user_name,
        contact_phone,
        phone_no } = this.form||{}
      if(this.showUsername)
        return user_name
      if(this.isPersonal) {
        if(this.isEmail) {
          return email
        }
        // account detail customer_profile 這裏用的 phone
        return contact_phone||mobile_no || phone || phone_no
      }

      if(!this.isEmail) {
        return contact_phone
      }
      if(this.isEdit&&!this.isPersonal)
        return  email
      return contact_email||email
    }
  },
  watch: {
    initReferContent: {
      immediate: true,
      handler(val, old) {
        this.sendFormData.referrer_content = val
      }
    },
  },
  mounted() {
    this.sendFormData.sms_content = this.initSmsContent
    this.sendFormData.email_content = this.initEmailContent
    this.sendFormData.share_content = this.initShareContent
    this.sendFormData.referrer_content =  this.initReferContent
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
      this.dialog = false
      this.$emit('input',false)
    },
    onSend() {
      this.$refs['send-form'].validate((valid, rules) => {
        if(valid) {
          this.dialog = false
          this.$emit('send',this.sendFormData)
          this.$emit('input',false)
        }
        else {
          console.log(rules)
        }
      })
    },
    onSkip() {
      this.dialog = false
      this.$emit('skip')
      this.$emit('input',false)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {

  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #1B1F23;
    }
  }
  .dialog-body{
    padding: 20px 15px;
  }
  h3 {
    padding-bottom: 10px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    margin: 15px -15px -15px;
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
  }
  .form-item {
    & > span {
      font-weight: 600;
      font-size: 14px;
    }
  }
}
</style>
